<template>
    <div style="display: none">
        <slot v-if="isOpen"></slot>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        name: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        width: {
            type: [String, Number],
            default: 450
        }
    },
    data() {
        return {
            isOpen: false
        };
    },
    methods: {
        show() {
            this.isOpen = true;
            this.$modal.show({
                render: (h) => h('div', { class: 'modal-content-wrapper small-modal' }, this.$slots.default)
            }, {}, {
                label: this.title,
                width: this.width,
                height: 'auto',
                adaptive: true,
                scrollable: true,
                classes: ['small-modal'],
                closed: () => {
                    this.isOpen = false;
                }
            });
        },
        hide() {
            this.$modal.close();
            this.isOpen = false;
        }
    }
};
</script>
